import React, { useMemo, useState, useEffect } from 'react';

const UserProfileCard: React.FC = () => {
	const [ userIndustry, setUserIndustry ] = useState('');
	const [ isLoading, setIsLoading ] = useState(true);

	const isEmptyObject = (obj: Record<string, unknown>) =>
		obj && Object.keys(obj).length === 0 && obj.constructor === Object;

	// get profileCardContent, return if empty
	const profileCardContent = window?._timken?.profileCardContent as {[key: string]: string} || {};
	if (! profileCardContent || isEmptyObject(profileCardContent)) {
		return null;
	}

	// get all industry images
	const industryImages = window?._timken?.industryImages as {[key: string]: string} || {};

	useEffect(() => {
		const handleAccountInfoLoaded = async (event) => {
			const industry = event.detail.accountInfo.industry;
			setUserIndustry(industry);
			setIsLoading(false);
		};

		document.addEventListener('timken_sso_account_info_loaded', handleAccountInfoLoaded);

		return () => {
			document.removeEventListener('timken_sso_account_info_loaded', handleAccountInfoLoaded);
		};
	}, []);

	const inlineStyle: React.CSSProperties & { [key: string]: string | number } = useMemo(() => {
		return {
			'--timken-profile-card-background-image': `url(${ industryImages[ userIndustry ] ? industryImages[ userIndustry ]['background_image'] : profileCardContent.bgImage })`,
		};
	}, [ industryImages[ userIndustry ] ? industryImages[ userIndustry ] : profileCardContent.bgImage ]);

	return (
		<>
			<div className="my-dashboard-profile-card" >
				<div className="my-dashboard-profile-card__content">
					<div className="my-dashboard-profile-card__title">
						Hi, <span className="sso-widget__profile-name">{/* gigya plugin populates the name */}</span></div>
					<div className="my-dashboard-profile-card__description">
						<p dangerouslySetInnerHTML={{ __html: profileCardContent.copy }}></p>
					</div>
				</div>
				<div className={`my-dashboard-profile-card__image ${ isLoading ? 't-full-block-skeleton' : '' }`} style={inlineStyle}>
				</div>
				<div className="my-dashboard-profile-card__actions">
					<a href={profileCardContent.linkUrl} className="link-underline">
						{profileCardContent.linkTitle}<i className='icon-external ms-2'></i></a>
				</div>
			</div>
		</>
	);
};

export default UserProfileCard;
